window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('dialog').length) {
    import('./_modal.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
